import React, { useState } from 'react';
import { menuItems } from '../data/mockData';

export const Menu = () => {
  const categories = ['All', ...new Set(menuItems.map(item => item.category))];
  const [selectedCategory, setSelectedCategory] = useState('All');

  const filteredItems = selectedCategory === 'All' 
    ? menuItems 
    : menuItems.filter(item => item.category === selectedCategory);

  return (
    <section id="menu" className="relative py-24 bg-gradient-to-b from-burgundy-900 via-red-900 to-burgundy-950 overflow-hidden">
      {/* Decorative Background */}
      <div className="absolute top-20 left-10 w-96 h-96 bg-orange-500/15 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 right-10 w-80 h-80 bg-yellow-500/15 rounded-full blur-3xl"></div>
      <div className="absolute top-1/2 left-1/3 w-72 h-72 bg-emerald-500/10 rounded-full blur-3xl"></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-orange-400 font-bold text-sm uppercase tracking-wider bg-orange-500/20 border border-orange-400/30 px-4 py-2 rounded-full">
            Our Menu
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-white mt-6 mb-4">
            Delicious Street Food
          </h2>
          <p className="text-orange-100 text-lg max-w-2xl mx-auto">
            Explore our curated selection of authentic Indian street food favorites, crafted fresh daily with premium ingredients
          </p>
        </div>

        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setSelectedCategory(category)}
              className={`px-6 py-3 rounded-full font-semibold transition-all duration-300 ${
                selectedCategory === category
                  ? 'bg-gradient-to-r from-orange-500 to-yellow-500 text-white shadow-lg shadow-orange-500/40 scale-105'
                  : 'bg-white/10 text-orange-200 hover:bg-white/20 backdrop-blur-sm border border-white/20'
              }`}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Menu Items Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredItems.map((item) => (
            <div
              key={item.id}
              className="group bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-md rounded-2xl overflow-hidden border border-orange-500/20 hover:border-orange-400/50 transition-all duration-300 hover:shadow-2xl hover:shadow-orange-500/30 hover:-translate-y-2"
            >
              {/* Image */}
              <div className="relative h-56 overflow-hidden">
                <img 
                  src={item.image}
                  alt={item.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-burgundy-900 via-transparent to-transparent opacity-60"></div>
                <div className="absolute top-4 right-4">
                  <span className="bg-gradient-to-r from-orange-500 to-yellow-500 text-white font-bold px-4 py-2 rounded-full text-sm shadow-lg">
                    {item.price}
                  </span>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <div className="mb-3">
                  <span className="text-orange-300 text-xs font-semibold uppercase tracking-wide bg-orange-500/20 px-3 py-1 rounded-full">
                    {item.category}
                  </span>
                </div>
                <h3 className="text-xl font-bold text-white mb-3 group-hover:text-orange-300 transition-colors">
                  {item.name}
                </h3>
                <p className="text-orange-100/80 text-sm leading-relaxed">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16">
          <p className="text-orange-100 mb-6 text-lg">
            Can't find what you're looking for? We offer custom menu options for events!
          </p>
          <button
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="bg-gradient-to-r from-orange-500 via-orange-600 to-yellow-500 text-white px-8 py-4 rounded-full font-semibold text-lg hover:from-orange-600 hover:via-orange-700 hover:to-yellow-600 transition-all duration-300 hover:scale-105 shadow-xl hover:shadow-orange-500/60"
          >
            Inquire About Custom Menu
          </button>
        </div>
      </div>
    </section>
  );
};
